import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-3">
            实时快讯
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            最新动态
          </h2>
          <p className="mt-2 text-sm text-foreground-500">漫画更新第一时间知晓，不错过任何精彩</p>
        </div>

        <div className="relative pl-6 md:pl-8 border-l-2 border-primary-200">
          {updatesData.map((item, index) => (
            <div key={index} className={`relative pb-8 ${index === updatesData.length - 1 ? 'pb-0' : ''}`}>
              <div className="absolute -left-[25px] md:-left-[29px] w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
              <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70">
                <div className="flex items-center gap-3 flex-wrap mb-2">
                  <span className="text-xs font-medium text-primary-600">{item.time}</span>
                  <span className="text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 font-medium">
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-heading text-base md:text-lg text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}